import { IPageStatus } from '@elem/compPage/stream-series-plug-in-solar-battery/config/IPageStatus';
import { useProductStore } from '@elem/compPage/stream-series-plug-in-solar-battery/ProductProvider';

export function isStatusC() {
    const { pageStatus } = useProductStore();
    return pageStatus === IPageStatus.statusC;
}
